import type { ComponentType } from 'react';
import classNames from 'classnames';
import Tooltip from 'rsuite/Tooltip';
import Whisper from 'rsuite/Whisper';
import './SideNavIcon.scss';
import { prefixClass } from 'lib/utils';

interface SideNavIconProps {
  Icon: ComponentType<any> | string;
  title?: string;
  beta?: boolean;
  selected?: boolean;
  badge?: number;
  tooltip?: string;
  SelectedIcon?: ComponentType<any> | string;
}

export default function SideNavIcon({
  Icon,
  title,
  beta,
  selected,
  badge,
  tooltip,
  SelectedIcon,
}: SideNavIconProps): JSX.Element {
  const prefix = prefixClass('side-nav-icon');
  const IconEl: ComponentType<any> =
    typeof Icon === 'string' ? (props: any) => <img src={Icon} alt={title} {...props} /> : Icon;
  const SelectedEl: ComponentType<any> | undefined = SelectedIcon
    ? typeof SelectedIcon === 'string'
      ? (props: any) => <img src={SelectedIcon} alt={title} {...props} />
      : SelectedIcon
    : undefined;

  return (
    <Whisper
      placement="right"
      controlId="control-id-hover"
      delay={800}
      delayClose={100}
      trigger="hover"
      speaker={<Tooltip>{tooltip || title}</Tooltip>}
    >
      <div className={classNames(prefix(), { 'snv-selected': selected })}>
        <div className={classNames(prefix('container'), { 'snv-selected': selected })}>
          <div className={classNames(prefix('container-icon'), { 'snv-selected': selected })}>
            {selected && SelectedEl ? <SelectedEl /> : <IconEl />}
          </div>
          <span>{title || ''}</span>
        </div>
        {beta && <span className={prefix('beta')}>Beta</span>}
        {badge && badge > 0 ? <span className={prefix('container-badge')}>{badge}</span> : null}
      </div>
    </Whisper>
  );
}
